import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "filter",
})
export class FilterPipe implements PipeTransform {
    transform(list: any[], args?: any[]): any {
        if (!Array.isArray(list)) return undefined;
        if (args === undefined) return undefined;
        if (!Array.isArray(args) || args.length === 0) return list;

        const validArgs = args.filter((arg) => arg && typeof arg === "object" && Object.keys(arg).length > 0);
        if (validArgs.length === 0) return list;

        return list.filter((item) =>
            validArgs.every((filter) =>
                Object.keys(filter).every((key) => {
                    if (!filter[key]) return true;
                    return item[key] === filter[key];
                })
            )
        );
    }
}
